import { DatePicker as AntDatePicker } from 'antd'
import moment from 'moment'
import type { Moment } from 'moment'
import momentGenerateConfig from 'rc-picker/lib/generate/moment'
import React from 'react'
import styled, { createGlobalStyle } from 'styled-components'

import { utcToTimezoneDate } from '../util/datetime'
import { insertTestingSelector, TestingKey } from '../util/testing'

import { DatePickerContainer } from './DatePickerContainer'

type Props = {
    disabled?: boolean
    label?: string
    errorMessage?: string
    hasDanger?: boolean
    onChange: (date: string) => void
    value?: string | null
    placeholder?: string
    size?: 'large' | 'medium' | 'small'
    disableIcon?: boolean
    disableClear?: boolean
    testingKeys?: [TestingKey] | [TestingKey, string]
    timezone?: string | null
}

export const MomentDatePicker = AntDatePicker.generatePicker<Moment>(momentGenerateConfig)

export const DatePicker = (props: Props): JSX.Element => {
    const {
        disabled,
        label,
        errorMessage,
        value,
        onChange,
        placeholder,
        size = 'medium',
        disableIcon,
        hasDanger,
        disableClear,
        testingKeys,
        timezone,
    } = props

    const momentValue = value ? moment(timezone ? utcToTimezoneDate(value, timezone) : value) : null
    const antdSize = size === 'medium' ? 'middle' : size
    const testingSelectors = testingKeys ? insertTestingSelector(...testingKeys) : {}

    return (
        <Container
            errorMessage={errorMessage}
            disabled={Boolean(disabled)}
            disableIcon={disableIcon}
            label={label}
            hasDanger={hasDanger}
        >
            <Global hasDanger={Boolean(hasDanger)} />
            <MomentDatePicker
                allowClear={disableClear}
                disabled={disabled}
                placeholder={placeholder}
                size={antdSize}
                onChange={(nextValue) => {
                    if (!nextValue) return
                    onChange(nextValue.toISOString())
                }}
                value={momentValue}
                {...testingSelectors}
            />
        </Container>
    )
}

const Global: any = createGlobalStyle<{ hasDanger: boolean }>`
  .ant-picker {
    
  }
  
`

const Container = styled(DatePickerContainer)``
